export default {"src":"/_next/static/media/apple-green.59b3bbab.svg","height":36,"width":30,"blurWidth":0,"blurHeight":0};